<div class="account-page">
  <div class="account-header">
    <h1 class="page-title">{{ 'ACCOUNT.TITLE' | translate }}</h1>
    <p class="page-subtitle">Manage your personal information and billing details</p>
  </div>

  @if (isLoading()) {
    <div class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <div class="account-sections">
      <app-general-account [accountData]="accountData()" [readOnly]="isJku()"></app-general-account>

      @if (!isJku()) {
        <app-billing-address [billingAddress]="billingAddress()"></app-billing-address>
      }
    </div>
  }
</div>